import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { setDoc, collection, addDoc } from "firebase/firestore";
import { db } from "./Firebase";
import { FormGroup } from "./CostCalculadora";
import { Alert, CloseButton } from "./App";
import { RiArrowGoBackFill } from "react-icons/ri";
import logoComercial from "./assets/logoComercialGris.png";
import { GrSend } from "react-icons/gr";
import DotLoader from "react-spinners/DotLoader";

const ContenedorLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40vh;
`;
const SpinnerContainerLoading = styled.div`
  width: auto;
  display: flex;
  margin-top: 10px;
`;
const SpinnerTexto = styled.div`
  font-weight: bold;
`;
const ContenedorFormBase = styled.div`
  width: 380px;
  padding: 0.5rem;
  border-radius: 8px;
  margin: 0rem 1rem 0 1rem;
  background-image: url(${require("./assets/logoGimnasia.svg").default});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 580px;
  background-color: rgba(255, 255, 255, 0.15);
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 330px;
  }
`;
const ContenedorHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ContenedorMensaje = styled.div`
  width: 100%;
  padding: 3rem;
  text-align: center;
  & img {
    margin-bottom: 1rem;
  }
`;
const FormGroupRadio = styled.div`
  display: flex;
  flex-direction: column;
  & label {
    font-size: small;
    font-weight: bold;
  }
`;
const EstiloButton = styled.button`
  margin-top: 1rem;
  padding: 5px;
  background-color: transparent;
  border: none;
  border-bottom: solid 1.5px #fb3b3b;
  font-weight: bold;
  font-size: large;
  &:hover {
    font-weight: 600;
    transition: 0.3s;
  }
`;
const SolicitudGimnasia = () => {
  const [fecha, setFecha] = useState("");
  const [empresa, setEmpresa] = useState("Club Gimnasia y Esgrima");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [fechaSalida, setFechaSalida] = useState("");
  const [horaSalida, setHoraSalida] = useState("");
  const [cantidadPasajeros, setCantidadPasajeros] = useState("");
  const [lugarSalida, setLugarSalida] = useState("");
  const [lugarDestino, setLugarDestino] = useState("");
  const [fechaRegreso, setFechaRegreso] = useState("");
  const [horaRegreso, setHoraRegreso] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [mensajeSolicitud, setMensajeSolicitud] = useState(false);
  const [guardandoDatos, setGuardandoDatos] = useState(false);
  const realizado = false;
  const [missingFields, setMissingFields] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
    setMensajeSolicitud(false);
  };

  // Utiliza el hook useEffect para establecer la fecha cuando se monta el componente
  useEffect(() => {
    const fechaActual = new Date();
    const dia = String(fechaActual.getDate()).padStart(2, "0");
    const mes = String(fechaActual.getMonth() + 1).padStart(2, "0"); // Los meses en JavaScript empiezan desde 0
    const ano = fechaActual.getFullYear();

    // Formato de fecha
    setFecha(`${ano}-${mes}-${dia}`);
  }, []); // El array vacío significa que este efecto se ejecutará solo una vez, cuando se monte el componente

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar que los campos obligatorios no estén vacíos
    const emptyFields = [];
    if (empresa.trim() === "") emptyFields.push("Nombre");
    if (email.trim() === "") emptyFields.push("Email");
    if (telefono.trim() === "") emptyFields.push("Teléfono");
    if (fechaSalida.trim() === "") emptyFields.push("Fecha de Salida");
    if (horaSalida.trim() === "") emptyFields.push("Hora de Salida");
    if (cantidadPasajeros.trim() === "")
      emptyFields.push("Cantidad de Pasajeros");
    if (lugarSalida.trim() === "") emptyFields.push("Lugar de Origen");
    if (lugarDestino.trim() === "") emptyFields.push("Lugar de Destino");

    if (emptyFields.length > 0) {
      setMissingFields(emptyFields); // Actualizar los campos faltantes
      setShowAlert(true);
      return;
    }

    setGuardandoDatos(true);

    // Guardar los datos en Firestore
    guardarEnFirestore();
    console.log("Todos los campos están completos");
  };

  const guardarEnFirestore = async () => {
    try {
      const presupuestosRef = collection(db, "solicitudes");
      const docRef = await addDoc(presupuestosRef, {
        fecha,
        empresa,
        email,
        telefono,
        fechaSalida,
        horaSalida,
        cantidadPasajeros,
        lugarSalida,
        lugarDestino,
        fechaRegreso: fechaRegreso === "" ? "solo ida" : fechaRegreso,
        horaRegreso,
        observaciones,
        realizado,
      });

      // Obtiene el ID del documento
      const docId = docRef.id;

      // Actualiza el documento para añadir el campo con el ID
      await setDoc(docRef, {
        docId: docId, // Añade el campo 'docId' con el ID del documento
        fecha,
        empresa,
        email,
        telefono,
        fechaSalida,
        horaSalida,
        cantidadPasajeros,
        lugarSalida,
        lugarDestino,
        fechaRegreso: fechaRegreso === "" ? "solo ida" : fechaRegreso,
        horaRegreso,
        observaciones,
        realizado,
      });

      // Reemplazar los saltos de línea por <br /> en observaciones
      const observacionesFormateadas = observaciones.replace(/\n/g, "<br />");

      // Añadir un nuevo documento a la colección 'mail' para enviar el correo electrónico
      await addDoc(collection(db, "mail"), {
        to: [
          "sanchez_marisa@catainternacional.com",
          "mendoza_dairelys@catainternacional.com",
          "carmona_juliana@catainternacional.com",
          "rojas_dario@catainternacional.com",
        ],
        from: `"Solicitud Gimnasia y Esgrima" <rojas_dario@catainternacional.com>`, // 👈 este es el remitente visible
        message: {
          subject: `Salida ${new Date(
            new Date(fechaSalida).toLocaleString("en-US", { timeZone: "UTC" })
          ).toLocaleDateString("es-ES")}`,
          text: `Salida ${new Date(
            new Date(fechaSalida).toLocaleString("en-US", { timeZone: "UTC" })
          ).toLocaleDateString("es-ES")}`,
          html: `<p style="margin: 0px; font-weight: bold;">Se ha recibido una nueva solicitud del Club Gimnasia con los siguientes datos:</p>
                   <br>
               <p style="margin: 0px; font-weight: bold;">${empresa}</p>
               <p style="margin: 0px;">Email: ${email}</p>
               <p style="margin: 0px;">Teléfono: ${telefono}</p>
               <p style="margin: 0px;">Fecha de Salida: ${new Date(
                 new Date(fechaSalida).toLocaleString("en-US", {
                   timeZone: "UTC",
                 })
               ).toLocaleDateString("es-ES")} - Hora: ${horaSalida}</p>
               <p style="margin: 0px;">Fecha de Regreso: ${new Date(
                 new Date(fechaRegreso).toLocaleString("en-US", {
                   timeZone: "UTC",
                 })
               ).toLocaleDateString("es-ES")} - Hora: ${horaRegreso}</p>
               <p style="margin: 0px;">Cantidad de Pasajeros: ${cantidadPasajeros}</p>
               <p style="margin: 0px;">Lugar de Salida: ${lugarSalida}</p>
               <p style="margin: 0px;">Lugar de Destino: ${lugarDestino}</p>
               <br>
               <p style="margin: 0px; font-weight: bold;">Observaciones:</p>
               <p style="margin: 0px;">${observacionesFormateadas}</p>
               <hr>
                <p style="margin: 0px; font-size: 12px; color: #555;">
                  Este es un correo automático generado por el sistema de presupuestos de CATA Internacional.
                </p>
               `,
        },
      });

      console.log("Queued email for delivery!");

      //Limpiar datos
      setEmail("");
      setTelefono("");
      setFechaSalida("");
      setHoraSalida("");
      setCantidadPasajeros("");
      setLugarSalida("");
      setLugarDestino("");
      setFechaRegreso("solo ida");
      setHoraRegreso("solo ida");
      setObservaciones("");
      setMensajeSolicitud(true);
      setGuardandoDatos(false);

      console.log("Datos guardados en firestore");
    } catch (error) {
      console.error("Error al guardar en Firestore:", error);
    }
  };

  return (
    <>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Por favor, completa los siguientes campos:{" "}
          <ul>
            {missingFields.map((field, index) => (
              <li key={index}>{field}</li>
            ))}
          </ul>
        </Alert>
      )}
      {mensajeSolicitud ? (
        <ContenedorMensaje>
          <img src={logoComercial} width="110" alt="Logo de CataComercial" />
          <h5>
            Se realizará una cotización para el servicio solicitado y se enviará
            el contrato correspondiente.
          </h5>
          <h5>En caso de cancelar el servicio comunicar por correo a:</h5>
          <h5>trafico@catainternacional.com, consulta@catacargo.com</h5>
          <p>Regresar al formulario</p>
          <RiArrowGoBackFill
            onClick={closeAlert}
            size={25}
            style={{ cursor: "pointer" }}
          />
        </ContenedorMensaje>
      ) : guardandoDatos ? (
        <ContenedorLoading>
          <SpinnerContainerLoading>
            <DotLoader color="#c20000" size={50} />
          </SpinnerContainerLoading>
          <SpinnerTexto>Enviando Solicitud</SpinnerTexto>
        </ContenedorLoading>
      ) : (
        <ContenedorFormBase>
          <ContenedorHeader>
            <h4>FORMULARIO DE SOLICITUD</h4>
          </ContenedorHeader>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <label>Nombre:</label>
              <input
                type="text"
                value={empresa}
                readOnly
                onChange={(e) => setEmpresa(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label>Email:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label>Teléfono:</label>
              <input
                type="tel"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label>Fecha de Salida:</label>
              <input
                type="date"
                value={fechaSalida}
                onChange={(e) => setFechaSalida(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label>Hora de Salida:</label>
              <input
                type="text"
                value={horaSalida}
                onChange={(e) => setHoraSalida(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label>Fecha de Regreso:</label>
              <input
                type="date"
                value={fechaRegreso}
                onChange={(e) => setFechaRegreso(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label>Hora de Regreso:</label>
              <input
                type="text"
                value={horaRegreso}
                onChange={(e) => setHoraRegreso(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label>Pasajeros:</label>
              <input
                type="number"
                value={cantidadPasajeros}
                onChange={(e) => setCantidadPasajeros(e.target.value)}
              />
            </FormGroup>
            <FormGroupRadio>
              <label>Desde:</label>
              <textarea
                rows="3"
                placeholder="País, ciudad, dirección"
                type="text"
                value={lugarSalida}
                onChange={(e) => setLugarSalida(e.target.value)}
              />
            </FormGroupRadio>
            <FormGroupRadio>
              <label>Hasta:</label>
              <textarea
                rows="3"
                placeholder="País, ciudad, dirección"
                type="text"
                value={lugarDestino}
                onChange={(e) => setLugarDestino(e.target.value)}
              />
            </FormGroupRadio>
            <FormGroupRadio>
              <label>Comentarios / Itinerario:</label>
              <textarea
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                rows="4"
              />
            </FormGroupRadio>

            <EstiloButton type="submit">
              Enviar Solicitud
              <GrSend style={{ marginLeft: 15 }} size={20} />
            </EstiloButton>
          </form>
        </ContenedorFormBase>
      )}
    </>
  );
};

export default SolicitudGimnasia;
